import React, { memo, useState } from 'react';
import { MdZoomIn, MdZoomOut, MdZoomOutMap } from 'react-icons/md';

import Viewer from 'bpmn-js/lib/NavigatedViewer';

import { Container, Content, Loading } from './styles';

function BpmnComponent({ data }) {
  const container = document.getElementById('canvas');
  const [loading, setLoading] = useState(true);

  if (data.xml) {
    const viewer = new Viewer({
      container,
    });

    viewer
      .importXML(String(data.xml))
      .then(({ warnings }) => {
        setLoading(false);

        if (warnings.length) {
          // eslint-disable-next-line no-console
          console.log('Warnings', warnings);
        }

        const canvas = viewer.get('canvas');
        const zoomScroll = viewer.get('zoomScroll');
        const { currentTask, deletedTasks } = data;
        let { previousTasks } = data;

        if (currentTask.length > 0) {
          currentTask.forEach((current) => {
            previousTasks = previousTasks.filter(
              (previousTask) =>
                previousTask.taskDefinitionKey !== current.taskDefinitionKey,
            );
          });
        }

        if (deletedTasks.length > 0) {
          deletedTasks.forEach((deletedTask) => {
            previousTasks = previousTasks.filter(
              (previousTask) =>
                previousTask.taskDefinitionKey !==
                deletedTask.taskDefinitionKey,
            );
          });
        }

        // Set color highlight
        if (currentTask.length > 0) {
          currentTask.forEach((task) => {
            canvas.addMarker(task.taskDefinitionKey, 'highlight');
          });
        }

        if (previousTasks.length > 0) {
          previousTasks.forEach((task) => {
            canvas.addMarker(task.taskDefinitionKey, 'previousTasksHighlight');
          });
        }

        if (deletedTasks.length > 0) {
          deletedTasks.forEach((task) => {
            canvas.addMarker(task.taskDefinitionKey, 'deletedTasksHighlight');
          });
        }

        canvas.zoom('fit-viewport', 'auto');

        const incrementId = document.getElementById('increment');
        incrementId.addEventListener('click', increment);

        const decrementId = document.getElementById('decrement');
        decrementId.addEventListener('click', decrement);

        const clearId = document.getElementById('clear');
        clearId.addEventListener('click', clear);

        function clear() {
          canvas.zoom('fit-viewport', 'auto');
        }

        function increment() {
          zoomScroll.stepZoom(1);
        }

        function decrement() {
          zoomScroll.stepZoom(-1);
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log('ERROR: ', err.message);
      });
  }

  return (
    <Container>
      {!loading ? (
        <Content>
          <div id="canvas" />
          <div className="zoomControl">
            <button type="button" id="clear" value="0">
              <MdZoomOutMap size={24} />
            </button>
            <button type="button" id="decrement" value="1">
              <MdZoomOut size={24} />
            </button>
            <button type="button" id="increment" value="1">
              <MdZoomIn size={24} />
            </button>
          </div>
        </Content>
      ) : (
        <Loading />
      )}
    </Container>
  );
}

export const Bpmn = memo(BpmnComponent);
